import React from 'react';
import { useLanguage } from '../i18nContext';
import StaticPageLayout from './StaticPageLayout';
import { Mail, MapPin, MessageCircle } from 'lucide-react';

interface Props { onBack: () => void; }

export default function ContactPage({ onBack }: Props) {
  const { language } = useLanguage();
  const en = language === 'en';

  const channels = [
    { icon: <Mail size={24} />, title: en ? 'Email' : '邮箱', desc: 'support@minutesai.com', sub: en ? 'We typically respond within 24 hours.' : '我们通常在 24 小时内回复。' },
    { icon: <MessageCircle size={24} />, title: en ? 'WeChat' : '微信', desc: en ? 'MinutesAI_Official' : 'MinutesAI_Official', sub: en ? 'Add our official WeChat for quick support.' : '添加官方微信获取快速支持。' },
    { icon: <MapPin size={24} />, title: en ? 'Office' : '办公地址', desc: en ? 'Beijing, China' : '中国北京', sub: en ? 'By appointment only.' : '仅限预约访问。' },
  ];

  return (
    <StaticPageLayout title={en ? 'Contact' : '联系我们'} onBack={onBack}>
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-brand-900 font-serif mb-4">
          {en ? 'Get in Touch' : '联系我们'}
        </h2>
        <p className="text-lg text-ink-secondary max-w-2xl mx-auto">
          {en ? "We'd love to hear from you. Reach out through any of the channels below." : '我们很乐意听到您的声音。请通过以下任一渠道联系我们。'}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {channels.map((ch, i) => (
          <div key={i} className="bg-white rounded-2xl border border-surface-border p-8 text-center">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-brand-900/10 mb-4 text-brand-900">
              {ch.icon}
            </div>
            <h3 className="text-lg font-bold text-brand-900 mb-1">{ch.title}</h3>
            <p className="text-brand-700 font-medium mb-2">{ch.desc}</p>
            <p className="text-sm text-ink-muted">{ch.sub}</p>
          </div>
        ))}
      </div>
    </StaticPageLayout>
  );
}
